import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { FurnizoriProiecteService } from '../furnizori-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { IFurnizorAddPayload, IFurnizorForm } from '../furnizori-proiecte.interface';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-add-furnizori-proiecte',
    templateUrl: './add-furnizori-proiecte.component.html',
    styleUrls: ['./add-furnizori-proiecte.component.scss']
})
export class AddFurnizoriProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    provider_type: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Firmă', value: '1' },
        { key: 'Instituție Publică (Regie Propie)', value: '2' },
        { key: 'Firmă și Instituție Publică', value: '3' },
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        provider_type: new FormControl('-1', [Validators.required, Validators.min(0)]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddFurnizoriProiecteComponent>,
        private furnizoriProiecteService: FurnizoriProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, provider_type } = this.form.value as IFurnizorForm;
        const payload: IFurnizorAddPayload = {
            name,
            provider_type
        };

        this.furnizoriProiecteService
            .addFurnizor(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
